var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-travel-medicine.f52a29ad.png","uri@2x": __webpack_public_path__ + "icon-travel-medicine.e69ed7a0.png","uri@3x": __webpack_public_path__ + "icon-travel-medicine.f585d49f.png",
    width: 20,
    height: 20
});